import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import { Link } from "react-router-dom";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const FAQNew = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <main className="wyscale_landing_main">
        <Header />
      </main>

      <section className="dashboard_content_section faq_page_wrapper">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("FrequentlyAskedQuestions")}</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content faq_ot">
                  <div className="contentpage">
                    <div className="container-fluid container-xl">
                      <div className="row bn_fq_row">
                        <div className="col-lg-6">
                          <div className="bn_faq_wrap">
                            <div
                              class="accordion accordion-flush bn_faq_accordion"
                              id="accordionFlushExample"
                            >
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingOne"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseOne"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseOne"
                                  >
                                    {t("WhatIsBinargeBot1")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseOne"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingOne"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("AIBasedTradingBot")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingTwo"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseTwo"
                                  >
                                    {t("IsBinargeAnInvestmentPlatform")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseTwo"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingTwo"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("BinargeIsNotAnInvestmentService")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingThree"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                  >
                                    {t("HowDoesBinargeBotWork")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseThree"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingThree"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("CreateAnAccountOnBinarge")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingFour"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFour"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseFour"
                                  >
                                    {t("WhatStrategiesDoesBotUse")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseFour"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingFour"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("DollarCostAveraging")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingFive"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFive"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseFive"
                                  >
                                    {t("DoINeedTradingExperience")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseFive"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingFive"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("DoINeedTradingExperienceAnswer")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingSix"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSix"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseSix"
                                  >
                                    {t("IsItSafeToUseBinarge")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseSix"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSix"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("IsItSafeToUseBinargeAnswer")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingSeven"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSeven"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseSeven"
                                  >
                                    {t("HowQuicklyReceiveProfits")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseSeven"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSeven"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("ProfitsDescription")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingEight"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseEight"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseEight"
                                  >
                                    {t("HowSubscriptionModelsWork")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseEight"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingEight"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {/* {t("SubscriptionModelsDescription")} */}
                                    <p>
                                      {t("BinargeOffersFourSubscriptionLevels")}
                                    </p>
                                    <ul>
                                      <li>{t("FreemiumFree")}</li>
                                      <li>{t("PremiumMonth")}</li>
                                      <li>{t("PremiumPlus")}</li>
                                      <li>{t("EliteTraderMonth")}</li>
                                    </ul>
                                    <p>
                                      {t(
                                        "AllSubscriptionPlansIncludeAPerformanceFeeModel"
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingNine"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseNine"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseNine"
                                  >
                                    {t("CanITryBinargeForFree")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseNine"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingNine"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("CanITryBinargeForFreeAnswer")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingTen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseTen"
                                  >
                                    {t("CanIUseMultipleStrategiesAtSameTime")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseTen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingTen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("CanUseMultipleStrategiesAnswer")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="bn_faq_wrap bn_faq_wrap_two">
                            <div
                              class="accordion accordion-flush bn_faq_accordion"
                              id="accordionFlushExample"
                            >
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingEleven"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseEleven"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseEleven"
                                  >
                                    {t("HowDoesFuelWalletWork")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseEleven"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingEleven"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("FuelWalletProfitSharingDescription")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingTwelve"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwelve"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseTwelve"
                                  >
                                    {t("HowDoesBinargeManageRisks")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseTwelve"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingTwelve"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("RiskManagementDescription")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingThirteen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThirteen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThirteen"
                                  >
                                    {t("WhichCryptoExchangesSupported")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseThirteen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingThirteen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("SupportedExchangesDescription")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingFourteen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFourteen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseFourteen"
                                  >
                                    {t("HowReferralProgramWorks")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseFourteen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingFourteen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("ReferralEarningsDescription")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingFifteen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFifteen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseFifteen"
                                  >
                                    {t("NeedColdWalletQuestion")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseFifteen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingFifteen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("ColdWalletExplanation")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingSixteen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSixteen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseSixteen"
                                  >
                                    {t("EarningsWithBinargeQuestion")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseSixteen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixteen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("EarningsWithBinargeExplanation")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingSeventeen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSeventeen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseSeventeen"
                                  >
                                    {t("WhereToGetHelpQuestion")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseSeventeen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSeventeen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("CustomerSupportDescription")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingEighteen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseEighteen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseEighteen"
                                  >
                                    {t("ProfitSharingTitle")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseEighteen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingEighteen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {/* {t("ProfitSharingDescription")}{" "} */}
                                    <p>{t("BinargeUsesAPerformance")}</p>
                                    <p>{t("FeeDistributionBySubscriptionLevel")}</p>
                                    <ul>
                                      <li>{t("FreemiumUser")}</li>
                                      <li>{t("PremiumUser")}</li>
                                      <li>{t("PromiumUser")}</li>
                                      <li>{t("EliteTraderUser")}</li>
                                    </ul>
                                    <p>{t("ParaUser")}</p>
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingNineteen"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseNineteen"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseNineteen"
                                  >
                                    {t("CancelSubscriptionQuestion")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseNineteen"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingNineteen"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("CancelSubscriptionExplanation")}
                                  </div>
                                </div>
                              </div>
                              <div class="bn_faq_item">
                                <h2
                                  class="bn_af_ac_header"
                                  id="flush-headingTwenty"
                                >
                                  <button
                                    class="bn_ln_faq_button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwenty"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseTwenty"
                                  >
                                    {t("InstructionsQuestion")}
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseTwenty"
                                  class="accordion-collapse collapse"
                                  aria-labelledby="flush-headingTwenty"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div class="bn_af_ac_body">
                                    {t("InstructionsAnswer")}{" "}
                                    <a
                                      target="_blank"
                                      href="https://www.youtube.com/@binargebot"
                                    >
                                      https://www.youtube.com/@binargebot
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SubFooter />
    </>
  );
};

export default FAQNew;
